import circleMenuSVG from '@plone/volto/icons/circle-menu.svg';

import { Data } from './Data';
import { Edit } from './Edit';
import { ChatbotHomeSchema } from './schema';
import { View } from './View';

export { Data, Edit, ChatbotHomeSchema, View };

export const chatbotHomeBlock = {
  id: '__iskra-chatbot-home',
  title: 'Chatbot Home',
  icon: circleMenuSVG,
  group: 'common',
  view: View,
  edit: Edit,
  restricted: false,
  mostUsed: true,
  sidebarTab: 1,
  security: {
    addPermission: [],
    view: [],
  },
};

export default chatbotHomeBlock;
